import gql from 'graphql-tag'
import slugify from 'slugify'

export const GetControls = (framework, lowLevelCategory, highLevelCategory, isFlat) => {
  const _lowLevelCategory = lowLevelCategory.replace(/\n/g, "\\n");

  return gql`query getControls($token: String) {
        controls( input:{
        framework: "${slugify(framework).toLowerCase()}"
        lowLevelCategory: "${_lowLevelCategory.toLowerCase()}"
        highLevelCategory: "${highLevelCategory.toLowerCase()}"
        flat: ${isFlat}
        nextToken: $token,
        limit: 10}){
        items{
          description
          controlID
          referenceID
          advice
          assetType
          securityFunction
          helpText
          hasSolution
          solutionTags
          standardOrder
          implementationName
          requiredAddressable
          controlOrder
          controlNanoID
          lowLevelCategoryNanoID
          highLevelCategoryNanoID
          frameworkID
        }
        nextToken
      }
      }`
}

export const GetControl = (flat, framework, highLevelCategory, lowLevelCategory, controlID) => {
  flat = Boolean(flat)
  return gql`query getControl {
    control(
          input: {
            flat: ${flat}
      framework: "${framework}"
      highLevelCategory: "${highLevelCategory}"
      lowLevelCategory: "${lowLevelCategory}"
      controlID: "${controlID}"
          }
    ){
      description
      referenceID
      controlID
      helpText
    }
  }`
}

export const GetControlStatus = () => {
  return gql`query controlStatus($controlData: [ControlStatusInput]) {
        controlStatus(input: $controlData){
        dueDate
        status
        assignedTo
        controlID
      }
      }`
}

export const GetControlBySectionID = () =>{
  return gql`query tasksBySectionId($input: TasksBySectionIdInput!){
    tasksBySectionId(input: $input) {
      assignedTo
      categoryId
      controlId
      dueDate
      frameworkId
      id
      referenceId
      updatedBy
      tenantId
      status
      sectionId
    }
    }`
}

/**
* @param {string} framework - The url name of the framework (sans-top-20)
* @param {string} highLevelCategory - The high level category
* @param {string} lowLevelCategory - The low level category
* @param {string} controlID - The control ID
*/
export const GetComments = (framework, lowLevelCategory, highLevelCategory, controlID) => {
  const _lowLevelCategory = lowLevelCategory.replace(/\n/g, "\\n");

  return gql`query getComments {
    getComments(input: {
      framework: "${slugify(framework).toLowerCase()}"
        lowLevelCategory: "${_lowLevelCategory.toLowerCase()}"
        highLevelCategory: "${highLevelCategory.toLowerCase()}"
        controlID: "${controlID}"
    })
    {
    createdBy
    createdAt
    comment
  }
  }`
}

export const SaveComment = () => {
  return gql`mutation createComment($commentData: CommentInput) {
    comment(input: $commentData)
  }`
}

export const SaveHelpText = () => {
  return gql`mutation addHelpTextToControl($helpTextData: AddHelpTextToControlInput){
    addHelpTextToControl(input: $helpTextData){
      helpText
    }
  }`
}

export const SetCompliant = () => {
  return gql`mutation setCompliant($controlData: ComplianceEventInput){
    markControlCompliant(input: $controlData) {
    status
  }
  }`
}

export const SetNotCompliant = () => {
  return gql`mutation setNotCompliant($controlData: ComplianceEventInput){
    markControlNotCompliant(input: $controlData) {
    status
  }
  }`
}

export const SetReadyReview = () => {
  return gql`mutation markReadyForReview($controlData: ComplianceEventInput){
    markControlReadyForReview(input: $controlData) {
    status
  }
  }`
}

export const SetNotSet = () => {
  return gql`mutation markNotSet($controlData: ComplianceEventInput){
    markControlNotSet(input: $controlData) {
    status
  }
  }`
}

export const SetAwaitingEvidence = () => {
  return gql`mutation markAwaitingEvidence($controlData: ComplianceEventInput){
    markControlAwaitingEvidence(input: $controlData) {
    status
  }
  }`
}

export const SetNotApplicable = () => {
  return gql`mutation markControlNotApplicable($controlData: ComplianceEventInput){
    markControlNotApplicable(input: $controlData) {
    status
  }
  }`
}

export const SetDueDate = () => {
  return gql`mutation setControlDueDate($controlData: ControlDueDateInput){
    setControlDueDate(input: $controlData) {
      dueDate
  }
  }`
}

export const SetAssignedTo = () => {
  return gql`mutation assignControl($controlData: AssignControlInput){
    assignControl(input: $controlData) {
      assignedTo
  }
  }`
}

export const SetUnassigned = () => {
  return gql`mutation unassignControl ($controlData: ComplianceEventInput!){
    unassignControl(input: $controlData){
      assignedTo
    }
  }`
}

export const GetDueControls = () => {
  return gql`query dueControls {
    dueControls {
      assignedTo
      controlID
      dueDate
      framework
      highLevelCategory
      lowLevelCategoryID
      lowLevelCategory
      referenceID
    }
  }`
}

export const GetDueControlsForUser = userSub => {

  return gql`query getControlsByAssignedUser {
    getControlsByAssignedUser(input:{
      user: "${userSub}"
    }){
      assignedTo
      controlID
      dueDate
      framework
      highLevelCategory
      lowLevelCategoryID
      lowLevelCategory
      referenceID
    }
  }`
}

export const SetControlStateV2 = () => {
  return gql`mutation setControlStatev2($controlData: ControlStateV2Input){
    setControlStatev2(input: $controlData)
  }`
}

export const SetStatusV2 = () => {
  return gql`mutation setStatus($controlData: SetStatusInput){
    setStatus(input: $controlData)
  }`
}

export const SetAssignedToV2 = () =>{
  return gql`mutation assignTask($controlData: AssignControlInputV2){
    assignTask(input: $controlData)
  }`
}

export const SetDueDateV2 = () =>{
  return gql`mutation setDueDate($controlData: SetDueDateInputV2){
    setDueDate(input: $controlData)
  }`
}

export const GetHelpText = () =>{
  return gql`query helpText($controlID: String!){
    helpText(controlID: $controlID) {
      controlId
      frameworkId
      helpText
      referenceId
      sectionId
    }
  }`
}






// WEBPACK FOOTER //
// ./src/queries/controls.js